import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AplicacionesComponent } from './aplicaciones/aplicaciones.component';
import { AdministradorComponent } from './administrador/administrador.component';
import { EditarMenuComponent } from './editar-menu/editar-menu.component';

import { ClientesComponent } from './clientes/clientes.component';
import {UsuarioAdminComponent} from './administrador/usuario-admin/usuario-admin.component';
import {TableAdminComponent} from './generico/tables/table-admin/table-admin.component';

import { TreeAccionMenuComponent } from './tree-accion-menu/tree-accion-menu.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LogoutComponent } from './logout/logout.component';
import { AuthPermisionGuard } from './generico/guard/auth-permision.guard';

import {CrearComponent } from './aplicaciones/crear/crear.component';


const routes: Routes = [
  { path: '',   redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'aplicaciones', component: AplicacionesComponent, canActivate: [AuthPermisionGuard] },
  { path: 'administrador', component: AdministradorComponent, canActivate: [AuthPermisionGuard] },
  { path: 'editar-menu', component: EditarMenuComponent, canActivate: [AuthPermisionGuard] },
  /* { path: 'tree-menu', component: TreeAccionMenuComponent } */
  { path: 'clientes', component: ClientesComponent, canActivate: [AuthPermisionGuard] },
  { path: 'usuario-admin', component: UsuarioAdminComponent, canActivate: [AuthPermisionGuard] },
  { path: 'table-admin', component: TableAdminComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthPermisionGuard] },
  { path: 'logout', component: LogoutComponent, canActivate: [AuthPermisionGuard] },
  { path: 'crear-aplic', component: CrearComponent},

  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
